import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {checkIsActive, KTSVG} from '../../../helpers'
import {useLayout, usePageData} from '../../core'
import { PAGE_PERMISSION } from '../../../../app/modules/roles/constant/role-default'
import { getDemoSectionAttributes, isDemoSectionVisible } from '../../../../app/modules/demo/demoMode'
import {useProjectSelection} from '../../../../app/modules/projectdetails/hooks/useProjectSelection'
import {isSelectionRouteDisabled} from '../../../../app/modules/projectdetails/selectionMode'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  children?: React.ReactNode
  pagePermission?: string[] | null
  hasBullet?: boolean
  demoSectionId?: string
}


const AsideMenuItem: React.FC<Props> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  pagePermission = null,
  hasBullet = false,
  demoSectionId,
}) => {
  const {pathname} = useLocation()
  const isActive = checkIsActive(pathname, to)
  const {isPortfolio} = useProjectSelection()
  const disabled = isSelectionRouteDisabled(to, isPortfolio)
  const {config} = useLayout()
  const {aside} = config
  const [canView, setCanView] = useState(true);
  const { currentUser: { activePages } } = usePageData();

  useEffect(() => {
    if (Array.isArray(pagePermission) && pagePermission.length > 0) {
      const allowed = pagePermission.some(perm => activePages.some(page => page.name === perm));
      setCanView(allowed);
    } else if (typeof pagePermission === 'string') {
      const allowed = activePages.some(page => page.name === pagePermission);
      setCanView(allowed);
    } else {
      setCanView(true);
    }
  }, [pagePermission, activePages]);

  if (!canView || !isDemoSectionVisible(demoSectionId))
    return <> </>

  const demoAttributes = getDemoSectionAttributes(demoSectionId) ?? {}

  return (
    <div {...demoAttributes} className={clsx('menu-item', {'menu-item-active': isActive})}>
      <Link
        className={clsx('menu-link without-sub rounded-3 px-4 py-3', {active: isActive && !disabled, 'opacity-50': disabled})}
        to={disabled ? '#' : to}
        title={disabled ? `${title} is unavailable in ${isPortfolio ? 'portfolio' : 'single-project'} mode` : title}
        aria-label={title}
        aria-disabled={disabled}
        tabIndex={disabled ? -1 : undefined}
        onClick={(event) => { if (disabled) event.preventDefault() }}
      >
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && aside.menuIcon === 'svg' && (
          <span className='menu-icon pe-none'>
            <KTSVG path={icon} className='svg-icon-2' />
          </span>
        )}
        {fontIcon && aside.menuIcon === 'font' && <i className={clsx('bi fs-3 pe-none', fontIcon)}></i>}
        <span className='menu-title fw-semibold'>{title}</span>
      </Link>
      {children}
    </div>
  )
}

export {AsideMenuItem}
